import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { AppContainer } from 'react-hot-loader';
import { addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en';
import de from 'react-intl/locale-data/de';
import { ThemeProvider } from 'styled-components';
import 'svgxuse';

import withTheme from './themeHOC';
import BaseApp from './components/App';
import MediaQueryWrapper from './components/MediaQueryWrapper';
import configureStore from './configureStore';
import { styledTheme as theme } from './theme';
import IntlProvider from './components/ConnectedIntlprovider';
import './css/fonts.css';
import './css/global.css';
import './css/global.fc.css';

const App = withTheme(BaseApp);

const preloadedState = window.REDUX_STATE || {};

const { store, persistor } = configureStore(preloadedState);// To change basename, put there the second param:
// const { store } = configureStore(window.REDUX_STATE, { basename: '/somewhere' })

addLocaleData([...en, ...de]);

const render = App => {
    const root = document.getElementById('root');

    ReactDOM.hydrate(
        <AppContainer>
            <Provider store={store}>
                <MediaQueryWrapper>
                    <IntlProvider>
                        <ThemeProvider theme={theme}>
                                    <App />
                        </ThemeProvider>
                    </IntlProvider>
                </MediaQueryWrapper>
            </Provider>
        </AppContainer>,
        root,
    );
};

render(App);

if (module.hot && process.env.NODE_ENV === 'development') {
    module.hot.accept('./components/App', () => {
        const App = require('./components/App').default
        render(App)
    })
}



// WEBPACK FOOTER //
// ./src/index.js